import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import country from 'ekkis-country-list-js'
import IsoToLatLong from 'country-iso-to-coordinates'
import Select from 'react-select';
import { toast } from 'react-toastify';
import locationServices from '../../../Services/locationServices'
import Loader from '../../../Components/Loader'


export const EditCountry = () => {
    const history = useHistory()
    let param = new URLSearchParams(history.location.search)
    const [countryList, setCountryList] = useState([])
    const [countryValue, setCountryValue] = useState('')
    const [loader, setLoader] = useState(true)

    useEffect(() => {
        let arry = []
        for (const key in country.all) {
            if (Object.hasOwnProperty.call(country.all, key)) {
                arry.push({ value: country.all[key].name, label: country.all[key].name, data: country.all[key] })
            }
        }
        setCountryList(arry)
    }, [])

    const getLatLong = (e) => {
        let country = IsoToLatLong[e.data.iso2]
        formik.setValues({
            ...formik.values,
            country_name: e.value,
            country_iso2: e.data.iso2,
            country_iso3: e.data.iso3,
            country_currency: e.data.currency,
            country_dial_code: e.data.dialing_code,
            lat: country.coordinate[0],
            long: country.coordinate[1],
              land_transit_time: e.land_transit_time,
            land_consolidation_transit_time:e.land_consolidation_transit_time,
        })
    }
    useEffect(() => {

        let postData = {
            country_id: param.get('id')
        }
        locationServices.getCountryDetails(postData).then(res => {
            if (res.status) {
                let data = res.data[0]
                setCountryValue({ value: data.country_name, label: data.country_name })
                formik.setValues({
                    ...formik.values,
                    country_name: data.country_name,
                    country_iso2: data.country_iso2,
                    country_iso3: data.country_iso3,
            
                    is_air_port_available: data.is_air_port_available,
                    is_air_consolidation_available: data.is_air_consolidation_available,
                    is_air_door_available: data.is_air_door_available,
                    air_on_request: data.air_on_request,

                    is_sea_port_available: data.is_sea_port_available,
                    is_sea_consolidation_available: data.is_sea_consolidation_available,
                    is_sea_door_available: data.is_sea_door_available,
                    sea_on_request: data.sea_on_request,

                    
                    is_land_consolidation_available: data.is_land_consolidation_available,
                    is_land_door_available: data.is_land_door_available,
                    land_on_request: data.land_on_request,

                    is_courier_port_available: data.is_courier_port_available,
                    is_courier_consolidation_available: data.is_courier_consolidation_available,
                    is_courier_door_available: data.is_courier_door_available,
                    // courier_on_request: data.courier_on_request,
                    caf_percent : data?.caf_percent || 0,
                    duty_tax_additional_fee : data?.duty_tax_additional_fee || 0,

                    land_transit_time: data.land_transit_time,
                    land_consolidation_transit_time:data.land_consolidation_transit_time,

                    country_currency: data.country_currency,
                    country_dial_code: data.country_dial_code,
                    lat: data.coordinates[1],
                    long: data.coordinates[0]
                })
                setLoader(false)
            }
        })
    }, [])
    const formik = useFormik({
        initialValues: {
            country_name: '',
            country_iso2: '',
            country_iso3: '',
            country_currency: '',
            country_dial_code: '',
            lat: '',
            long: '',
            caf_percent : "",
            duty_tax_additional_fee : "",
            land_transit_time: '',
            land_consolidation_transit_time: ''
        },
        validationSchema: Yup.object({
            country_currency: Yup.string()
                .min(2, 'Must be 2 characters or more')
                .required('Required'),
            country_dial_code: Yup.string().required('Required'),
            country_name: Yup.string().required('Required'),
            country_iso2: Yup.string().required('Required'),
            country_iso3: Yup.string().required('Required'),
            lat: Yup.string().required('Required'),
            long: Yup.string().required('Required'),
             land_transit_time: Yup.string().required('Required'),
            land_consolidation_transit_time: Yup.string().required('Required'),
        }),
        onSubmit: values => {
            setLoader(true)
            let postData = {
                ...values,
                coordinates: [values.long, values.lat],
                country_id: param.get('id')
            }
            locationServices.updateCountry(postData).then(res => {
                if (res.status) {
                    setLoader(false)
                    history.goBack()
                } else {
                    setLoader(false)
                    toast.error(res.message)
                }
            })
        },
    });

    const onChangeCountry = (e) => {
        getLatLong(e)
        setCountryValue(e)
    }

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <form className="control-form">
                            <div className="mb-3">
                                <label className="form-label" >Country name</label>
                                <Select
                                    styles={{
                                        valueContainer: (provided) => ({
                                            ...provided,
                                            height: 'calc(2.15rem + 2px)',
                                            overflowY: 'visible'
                                        }),
                                        control: (provider) => ({
                                            ...provider,
                                            borderColor: formik.touched.country_name ? !formik.errors.country_name ? '#34c38f' : '#f46a6a' : '#ced4da',
                                            boxShadow: '0 0 0 0px #f46a6a'
                                        }),
                                        placeholder: (provider) => ({
                                            ...provider,
                                            color: '#a0b0ca'
                                        })
                                    }}
                                    value={countryValue}
                                    onChange={(e) => onChangeCountry(e)}
                                    options={countryList}
                                />
                                {formik.touched.country_name && formik.errors.country_name ? (
                                    <div className="text-danger">{formik.errors.country_name}</div>
                                ) : null}
                            </div>
                            <div className="d-none">
                                <div className="row">
                                    <div className="mb-3 col-6">
                                        <label className="form-label" htmlFor="country currency">Currency code</label>
                                        <input
                                            disabled
                                            className={'form-control' + (formik.touched.country_currency ? !formik.errors.country_currency ? ' is-valid' : ' is-invalid' : '')}
                                            {...formik.getFieldProps('country_currency')}
                                            placeholder="Enter currency code"
                                        />
                                        {formik.touched.country_currency && formik.errors.country_currency ? (
                                            <div className="text-danger">{formik.errors.country_currency}</div>
                                        ) : null}
                                    </div>
                                    <div className="mb-3 col-6">
                                        <label className="form-label">Dial code</label>
                                        <input
                                            disabled
                                            className={'form-control' + (formik.touched.country_dial_code ? !formik.errors.country_dial_code ? ' is-valid' : ' is-invalid' : '')}
                                            {...formik.getFieldProps('country_dial_code')}
                                            placeholder="Enter dial code"
                                        />
                                        {formik.touched.country_dial_code && formik.errors.country_dial_code ? (
                                            <div className="text-danger">{formik.errors.country_dial_code}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="mb-3 col-6">
                                        <label className="form-label">Iso2</label>
                                        <input
                                            disabled
                                            className={'form-control' + (formik.touched.country_iso2 ? !formik.errors.country_iso2 ? ' is-valid' : ' is-invalid' : '')}
                                            {...formik.getFieldProps('country_iso2')}
                                            placeholder="Enter iso2"
                                        />
                                        {formik.touched.country_iso2 && formik.errors.country_iso2 ? (
                                            <div className="text-danger">{formik.errors.country_iso2}</div>
                                        ) : null}
                                    </div>
                                    <div className="mb-3 col-6">
                                        <label className="form-label">Iso3</label>
                                        <input
                                            disabled
                                            className={'form-control' + (formik.touched.country_iso3 ? !formik.errors.country_iso3 ? ' is-valid' : ' is-invalid' : '')}
                                            {...formik.getFieldProps('country_iso3')}
                                            placeholder="Enter iso3"
                                        />
                                        {formik.touched.country_iso3 && formik.errors.country_iso3 ? (
                                            <div className="text-danger">{formik.errors.country_iso3}</div>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                            <div className="border-custom">
                                <h5>Air</h5>
                                <div className="row my-3">
                                    <div className="mb-3 col-3">
                                        <div className="d-flex justify-content-start">
                                            <label className="form-label px-2">Air Port Delivery : </label>
                                            <input
                                                id="is_air_port_available"
                                                type="checkbox"
                                                switch="success"
                                                checked={formik.values.is_air_port_available}
                                                {...formik.getFieldProps('is_air_port_available')}
                                            />
                                            <label htmlFor="is_air_port_available" data-on-label="Yes" data-off-label="No" />
                                        </div>
                                        {formik.touched.is_air_port_available && formik.errors.is_air_port_available ? (
                                            <div className="text-danger">{formik.errors.is_air_port_available}</div>
                                        ) : null}
                                    </div>
                                    <div className="mb-3 col-3">
                                        <div className="d-flex justify-content-start">
                                            <label className="form-label px-2"> Air Door Delivery : </label>
                                            <input
                                                id="is_air_door_available"
                                                type="checkbox"
                                                switch="success"
                                                checked={formik.values.is_air_door_available}
                                                {...formik.getFieldProps('is_air_door_available')}
                                            />
                                            <label htmlFor="is_air_door_available" data-on-label="Yes" data-off-label="No" />
                                        </div>
                                        {formik.touched.is_air_door_available && formik.errors.is_air_door_available ? (
                                            <div className="text-danger">{formik.errors.is_air_door_available}</div>
                                        ) : null}
                                    </div>
                                    <div className="mb-3 col-3">
                                        <div className="d-flex justify-content-start">
                                            <label className="form-label px-2" htmlFor="country currency">Air Consolidation Delivery : </label>
                                            <input
                                                type="checkbox"
                                                id="is_air_consolidation_available"
                                                switch="success"
                                                checked={formik.values.is_air_consolidation_available}
                                                {...formik.getFieldProps('is_air_consolidation_available')}
                                            />
                                            <label htmlFor="is_air_consolidation_available" data-on-label="Yes" data-off-label="No" />
                                        </div>
                                        {formik.touched.is_air_consolidation_available && formik.errors.is_air_consolidation_available ? (
                                            <div className="text-danger">{formik.errors.is_air_consolidation_available}</div>
                                        ) : null}
                                    </div>

                                    <div className="mb-3 col-3">
                                        <div className="d-flex justify-content-start">
                                            <label className="form-label px-2" htmlFor="country currency">Air On Request : </label>
                                            <input
                                                type="checkbox"
                                                id="air_on_request"
                                                switch="success"
                                                checked={formik.values.air_on_request}
                                                {...formik.getFieldProps('air_on_request')}
                                            />
                                            <label htmlFor="air_on_request" data-on-label="Yes" data-off-label="No" />
                                        </div>
                                        {formik.touched.air_on_request && formik.errors.air_on_request ? (
                                            <div className="text-danger">{formik.errors.air_on_request}</div>
                                        ) : null}
                                    </div>


                                </div>
                            </div>
                            <div className="border-custom">
                                <h5>Sea</h5>
                                <div className="row my-3">
                                    <div className="mb-3 col-3">
                                        <div className="d-flex justify-content-start">
                                            <label className="form-label px-2"> Sea Port Delivery : </label>
                                            <input
                                                id="is_sea_port_available"
                                                type="checkbox"
                                                switch="success"
                                                checked={formik.values.is_sea_port_available}
                                                {...formik.getFieldProps('is_sea_port_available')}
                                            />
                                            <label htmlFor="is_sea_port_available" data-on-label="Yes" data-off-label="No" />
                                        </div>
                                        {formik.touched.is_sea_port_available && formik.errors.is_sea_port_available ? (
                                            <div className="text-danger">{formik.errors.is_sea_port_available}</div>
                                        ) : null}
                                    </div>
                                    <div className="mb-3 col-3">
                                        <div className="d-flex justify-content-start">
                                            <label className="form-label px-2"> Sea Door Delivery : </label>
                                            <input
                                                id="is_sea_door_available"
                                                type="checkbox"
                                                switch="success"
                                                checked={formik.values.is_sea_door_available}
                                                {...formik.getFieldProps('is_sea_door_available')}
                                            />
                                            <label htmlFor="is_sea_door_available" data-on-label="Yes" data-off-label="No" />
                                        </div>
                                        {formik.touched.is_sea_door_available && formik.errors.is_sea_door_available ? (
                                            <div className="text-danger">{formik.errors.is_sea_door_available}</div>
                                        ) : null}
                                    </div>
                                    <div className="mb-3 col-3">
                                        <div className="d-flex justify-content-start">
                                            <label className="form-label px-2" htmlFor="country currency"> Sea Consolidation Delivery : </label>
                                            <input
                                                type="checkbox"
                                                id="is_sea_consolidation_available"
                                                switch="success"
                                                checked={formik.values.is_sea_consolidation_available}
                                                {...formik.getFieldProps('is_sea_consolidation_available')}
                                            />
                                            <label htmlFor="is_sea_consolidation_available" data-on-label="Yes" data-off-label="No" />
                                        </div>
                                        {formik.touched.is_sea_consolidation_available && formik.errors.is_sea_consolidation_available ? (
                                            <div className="text-danger">{formik.errors.is_sea_consolidation_available}</div>
                                        ) : null}
                                    </div>

                                    <div className="mb-3 col-3">
                                        <div className="d-flex justify-content-start">
                                            <label className="form-label px-2" htmlFor="country currency">Sea On Request : </label>
                                            <input
                                                type="checkbox"
                                                id="sea_on_request"
                                                switch="success"
                                                checked={formik.values.sea_on_request}
                                                {...formik.getFieldProps('sea_on_request')}
                                            />
                                            <label htmlFor="sea_on_request" data-on-label="Yes" data-off-label="No" />
                                        </div>
                                        {formik.touched.sea_on_request && formik.errors.sea_on_request ? (
                                            <div className="text-danger">{formik.errors.sea_on_request}</div>
                                        ) : null}
                                    </div>

                                </div>
                            </div>
                            <div className="border-custom">
                                <h5>Courier</h5>
                                <div className="row my-3">
                                    {/* <div className="mb-3 col-3">
                                        <div className="d-flex justify-content-start">
                                            <label className="form-label px-2"> Courier Port Delivery : </label>
                                            <input
                                                id="is_courier_port_available"
                                                type="checkbox"
                                                switch="success"
                                                checked={formik.values.is_courier_port_available}
                                                {...formik.getFieldProps('is_courier_port_available')}
                                            />
                                            <label htmlFor="is_courier_port_available" data-on-label="Yes" data-off-label="No" />
                                        </div>
                                        {formik.touched.is_courier_port_available && formik.errors.is_courier_port_available ? (
                                            <div className="text-danger">{formik.errors.is_courier_port_available}</div>
                                        ) : null}

                                    </div> */}
                                    <div className="mb-3 col-4">
                                        <div className="d-flex justify-content-start">
                                            <label className="form-label px-2"> Courier Door Delivery : </label>
                                            <input
                                                id="is_courier_door_available"
                                                type="checkbox"
                                                switch="success"
                                                checked={formik.values.is_courier_door_available}
                                                {...formik.getFieldProps('is_courier_door_available')}
                                            />
                                            <label htmlFor="is_courier_door_available" data-on-label="Yes" data-off-label="No" />
                                        </div>
                                        {formik.touched.is_courier_door_available && formik.errors.is_courier_door_available ? (
                                            <div className="text-danger">{formik.errors.is_courier_door_available}</div>
                                        ) : null}
                                    </div>
                                    <div className="mb-3 col-4">
                                        <div className="d-flex justify-content-start">
                                            <label className="form-label px-2" htmlFor="country currency"> Courier Consolidation Delivery : </label>
                                            <input
                                                type="checkbox"
                                                id="is_courier_consolidation_available"
                                                switch="success"
                                                checked={formik.values.is_courier_consolidation_available}
                                                {...formik.getFieldProps('is_courier_consolidation_available')}
                                            />
                                            <label htmlFor="is_courier_consolidation_available" data-on-label="Yes" data-off-label="No" />
                                        </div>
                                        {formik.touched.is_courier_consolidation_available && formik.errors.is_courier_consolidation_available ? (
                                            <div className="text-danger">{formik.errors.is_courier_consolidation_available}</div>
                                        ) : null}
                                    </div>

                                    {/* <div className="mb-3 col-3">
                                        <div className="d-flex justify-content-start">
                                            <label className="form-label px-2" htmlFor="country currency"> Courier On Request : </label>
                                            <input
                                                type="checkbox"
                                                id="courier_on_request"
                                                switch="success"
                                                checked={formik.values.courier_on_request}
                                                {...formik.getFieldProps('courier_on_request')}
                                            />
                                            <label htmlFor="courier_on_request" data-on-label="Yes" data-off-label="No" />
                                        </div>
                                        {formik.touched.courier_on_request && formik.errors.courier_on_request ? (
                                            <div className="text-danger">{formik.errors.courier_on_request}</div>
                                        ) : null}
                                    </div> */}
                                </div>
                            </div>
                            <div className="border-custom">
                                <h5>Land</h5>
                                <div className="row my-3">
{/* 
                                    <div className="mb-3 col-3">
                                        <div className="d-flex justify-content-start">
                                            <label className="form-label px-2"> Land Port Delivery : </label>
                                            <input
                                                id="is_land_port_available"
                                                type="checkbox"
                                                switch="success"
                                                checked={formik.values.is_land_port_available}
                                                {...formik.getFieldProps('is_land_port_available')}
                                            />
                                            <label htmlFor="is_land_port_available" data-on-label="Yes" data-off-label="No" />
                                        </div>
                                        {formik.touched.is_land_port_available && formik.errors.is_land_port_available ? (
                                            <div className="text-danger">{formik.errors.is_land_port_available}</div>
                                        ) : null}
                                    </div> */}
                                    <div className="mb-4 col-3">
                                        <div className="d-flex justify-content-start">
                                            <label className="form-label px-2"> Land Door Delivery : </label>
                                            <input
                                                id="is_land_door_available"
                                                type="checkbox"
                                                switch="success"
                                                checked={formik.values.is_land_door_available}
                                                {...formik.getFieldProps('is_land_door_available')}
                                            />
                                            <label htmlFor="is_land_door_available" data-on-label="Yes" data-off-label="No" />
                                        </div>
                                        {formik.touched.is_land_door_available && formik.errors.is_land_door_available ? (
                                            <div className="text-danger">{formik.errors.is_land_door_available}</div>
                                        ) : null}
                                    </div>
                                    <div className="mb-4 col-3">
                                        <div className="d-flex justify-content-start">
                                            <label className="form-label px-2" htmlFor="country currency"> Land Consolidation Delivery : </label>
                                            <input
                                                type="checkbox"
                                                id="is_land_consolidation_available"
                                                switch="success"
                                                checked={formik.values.is_land_consolidation_available}
                                                {...formik.getFieldProps('is_land_consolidation_available')}
                                            />
                                            <label htmlFor="is_land_consolidation_available" data-on-label="Yes" data-off-label="No" />
                                        </div>
                                        {formik.touched.is_land_consolidation_available && formik.errors.is_land_consolidation_available ? (
                                            <div className="text-danger">{formik.errors.is_land_consolidation_available}</div>
                                        ) : null}
                                    </div>
                                    <div className="mb-4 col-6">
                                        <div className="d-flex justify-content-start">
                                            <label className="form-label px-2" htmlFor="country currency">Land On Request : </label>
                                            <input
                                                type="checkbox"
                                                id="land_on_request"
                                                switch="success"
                                                checked={formik.values.land_on_request}
                                                {...formik.getFieldProps('land_on_request')}
                                            />
                                            <label htmlFor="land_on_request" data-on-label="Yes" data-off-label="No" />
                                        </div>
                                        {formik.touched.land_on_request && formik.errors.land_on_request ? (
                                            <div className="text-danger">{formik.errors.land_on_request}</div>
                                        ) : null}
                                    </div>
                                    <div className="mb-3 ms-2 col-3">
                                        <label className="form-label">Land Transact Time</label>
                                        <input
                                            className={'form-control'}
                                            type='number'
                                            {...formik.getFieldProps('land_transit_time')}
                                            placeholder="Enter Land Transact Time"
                                        />
                                        {formik.touched.land_transit_time && formik.errors.land_transit_time ? (
                                                <div className="text-danger">{formik.errors.land_transit_time}</div>
                                            ) : null}
                                    </div>
                                    <div className="mb-3 col-3">
                                        <label className="form-label">Land Consolidation Transact Time</label>
                                        <input
                                            className={'form-control'}
                                            type='number'
                                            {...formik.getFieldProps('land_consolidation_transit_time')}
                                            placeholder="Enter Land Consolidation Transact Time"
                                        />
                                        {formik.touched.land_consolidation_transit_time && formik.errors.land_consolidation_transit_time ? (
                                                <div className="text-danger">{formik.errors.land_consolidation_transit_time}</div>
                                            ) : null}
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label">Latitude</label>
                                    <input
                                        disabled
                                        className={'form-control' + (formik.touched.lat ? !formik.errors.lat ? ' is-valid' : ' is-invalid' : '')}
                                        {...formik.getFieldProps('lat')}
                                        placeholder="Enter latitude"
                                    />
                                    {formik.touched.lat && formik.errors.lat ? (
                                        <div className="text-danger">{formik.errors.lat}</div>
                                    ) : null}
                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label">Longitude</label>
                                    <input
                                        disabled
                                        className={'form-control' + (formik.touched.long ? !formik.errors.long ? ' is-valid' : ' is-invalid' : '')}
                                        {...formik.getFieldProps('long')}
                                        placeholder="Enter longitude"
                                    />
                                    {formik.touched.long && formik.errors.long ? (
                                        <div className="text-danger">{formik.errors.long}</div>
                                    ) : null}
                                </div>
                            </div>

                            <div className="border-custom">
                                <h5>Duty And Taxes</h5>
                                <div className="row my-3">

                                <div className="mb-3 col-6">
                                    <label className="form-label">CAF ( Currency Adjustment Factor ) %</label>
                                    <input
                                        className={'form-control'}
                                        type='number'
                                        {...formik.getFieldProps('caf_percent')}
                                        placeholder="Enter CAF %"
                                    />
                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label">Additional Fee</label>
                                    <input
                                        className={'form-control'}
                                        type='number'
                                        {...formik.getFieldProps('duty_tax_additional_fee')}
                                        placeholder="Enter Additional Fee"
                                    />
                                </div>
                                </div>
                            </div>

                            <div className="mt-3 d-flex justify-content-between">
                                <button
                                    className="btn btn-danger w-sm waves-effect waves-light"
                                    type="button"
                                    onClick={() => history.goBack()}
                                >Back</button>
                                <button className="btn btn-primary w-sm waves-effect waves-light"
                                    type="button"
                                    onClick={() => formik.handleSubmit()}
                                >Submit</button>
                            </div>
                        </form>
                    </div>
                    <Loader isShow={loader} />
                </div>
            </div>
        </div>
    )
}
